"use strict";

const passwordFields = document.querySelectorAll(".form-input__password");

passwordFields.forEach((field) => {
  const passwordInput = field.querySelector(".form-input__input");
  const showPasswordButton = field.querySelector(".form-input__password-show");
  const hidePasswordButton = field.querySelector(".form-input__password-hide");

  showPasswordButton.addEventListener("click", () => {
    showPasswordButton.style.display = "none";
    hidePasswordButton.style.display = "block";
    passwordInput.type = "text";
  });

  hidePasswordButton.addEventListener("click", () => {
    hidePasswordButton.style.display = "none";
    showPasswordButton.style.display = "block";
    passwordInput.type = "password";
  });
});
